export default {
  // redeem
  REDEEM_PROMO_CODE: (promoCode) => {
    return `/redeem?promo_code=${promoCode}`;
  },
  // public
  COMING: '/coming-soon',
  TOS: '/term-of-service',
  PRIVACYPOLICY: '/privacy-policy',

  // Auth
  AUTH: '/auth',
  LOGIN: '/auth/login',
  SIGNUP: '/auth/signup',
  FORGOT_PASSWORD: '/auth/forgot-password',
  EMAIL_VERIFICATION: '/auth/email-verification',
  NEW_PASSWORD: '/auth/new-password',

  LANDING: '/',
  COMPONENTS: '/components',

  // admin section
  // users
  CREATE_ROLE: '/users/roles/create',
  EDIT_ROLE: (roleId) => {
    return `/users/roles/${roleId}`;
  },
  ROLES: '/users/roles',
  USERS: '/users',

  TEAMS: '/teams',

  // team setting
  TEAM_SETTINGS: '/team-setting',
  TEAM_SETTINGS_LICENSE: '/team-setting/license',

  // licenses
  LICENSES: '/licenses',

  PAYMENTS: '/payments',

  // user section
  // contacts
  CONTACTS: '/contacts',
  CONTACTS_CREATE: '/contacts/create',
  CONTACT_DETAIL: (contactId) => {
    return `/contacts/${contactId}/detail`;
  },
  CONTACT_EDIT: (contactId) => {
    return `/contacts/${contactId}/edit`;
  },

  // team members
  MEMBERS: '/members',
  MEMBERS_ROLE: '/members/roles',
  MEMBERS_CREATE_ROLE: '/members/roles/create',
  MEMBERS_EDIT_ROLE: (id) => {
    return `/members/roles/${id}`;
  },

  // accounts
  ACCOUNTS: '/accounts',
  ACCOUNTS_PASSWORD: '/accounts/password',
  ACCOUNTS_LICENSE: '/accounts/license',

  NOTIFICATIONS: '/notifications',

  // dashboard
  DASHBOARD: '/Dashboard',
  DASHBOARD_FULL_CALENDAR: '/dashboard/calendar',

  // scribers
  SCRIBERS: '/scribers',

  // promoter
  PROMOTER_CAMPAIGNS: '/promoter/campaigns',
  PROMOTER_CAMPAIGNS_DETAIL: (campaignId) => {
    return `/promoter/campaigns/${campaignId}`;
  },
  PROMOTER_AD_SETS: '/promoter/ad-sets',
  PROMOTER_AD_SETS_DETAIL: (adSetId) => {
    return `/promoter/ad-sets/${adSetId}`;
  },
  PROMOTER_ADS_EDIT: (adId) => {
    return `/promoter/ads/${adId}/edit`;
  },
  PROMOTER_ADS_CREATE: '/promoter/ads/create',
  PROMOTER_ADS: '/promoter/ads',
  PROMOTER: '/promoter',

  // social accounts
  SOCIAL_ACCOUNTS: '/social-accounts',
  SOCIAL_ACCOUNTS_CONNECT: (type) => {
    return `/social-accounts/connect/${type}`;
  },
  SOCIAL_ACCOUNTS_CONNECT_FINAL: (type) => {
    return `/social-accounts/connect/${type}/final`;
  },
  SOCIAL_ACCOUNTS_CONNECT_FB:
    '/social-accounts/connect/facebook/select-profile',

  // integrator
  INTEGRATOR_DECLINE: '/integrator/decline',
  INTEGRATOR_PUBLISHED: '/integrator/published',
  INTEGRATOR_APPROVAL: '/integrator/approval',
  INTEGRATOR_DRAFT: '/integrator/draft',
  INTEGRATOR_VERIFIED: '/integrator/verified',
  INTEGRATOR: '/integrator',
  INTEGRATOR_NEW: '/integrator/new',
  INTEGRATOR_DETAIL: (integratorId) => {
    return `/integrator/${integratorId}/detail`;
  },
  INTEGRATOR_EDIT: (integratorId) => {
    return `/integrator/${integratorId}/edit`;
  },

  // analyzer
  ANALYZER: '/analyzers',
  ANALYZER_NEW_REPORT: '/analyzers/new-report',
  ANALYZER_DETAIL: (analyzerId) => {
    return `/analyzers/${analyzerId}`;
  },
  ANALYZER_PRINT: (analyzerId) => {
    return `/analyzers-print/${analyzerId}`;
  },
  // ANALYZER_REPORT: (analyzerId) => {
  //   return `/analyzers/${analyzerId}`;
  // },
  ANALYZER_POS: (analyzerId) => {
    return `/analyzers/${analyzerId}/redemption`;
  },

  // refiner
  REFINER: '/refiners',
  REFINER_NEW_REPORT: '/refiners/new-report',
  REFINER_DETAIL: (refinerId) => {
    return `/refiners/${refinerId}`;
  },
  REFINER_EDIT: (refinerId) => {
    return `/refiners/${refinerId}/edit`;
  },

  // setting
  SETTING: '/setting',
};
